import { APP_INITIALIZER, Provider } from '@angular/core';

import { FeatureFlagsService } from '../services/feature-flags.service';

export function featureFlagsInitializerFactory(service: FeatureFlagsService): () => Promise<void> {
    return () => service.init();
}

export const FEATURE_FLAGS_INITIALIZER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: featureFlagsInitializerFactory,
    deps: [FeatureFlagsService],
    multi: true
};
